import { gql } from "gql";
import { ProductSwitchOffer } from "gql/graphql";
import { apolloClient } from "./apolloClient";
import { trackTask } from "src/utils/monitoring/events/tasks";
import { getActiveUser } from "@noom/hive-auth";

export const PRODUCT_SWITCH_OFFERS_QUERY = gql(`
  query ProductSwitchOffers($accessCode: String) {
    productSwitchOffers(accessCode: $accessCode) {
      offers {
        productName
        saleItemId
        price {
          currencyCode
          units
          nanos
        }
        trialPrice {
          currencyCode
          units
          nanos
        }
        trialSaleItemId
        isNextBillingCycleSwitch
      }
    }
  }
`);

export async function queryProductSwitchOffers(): Promise<
  ProductSwitchOffer[]
> {
  const task = trackTask("QueryProductSwitchOffers");
  task.start();

  const activeUser = getActiveUser();

  if (!activeUser?.accessCode) {
    task.failed(new Error("User not authenticated"));
    return [];
  }

  const { accessCode } = activeUser;

  try {
    const result = await apolloClient.query({
      query: PRODUCT_SWITCH_OFFERS_QUERY,
      variables: { accessCode },
    });

    const offers = result.data?.productSwitchOffers?.offers ?? [];
    task.success({ offerCount: offers.length, accessCode });
    return offers;
  } catch (error: any) {
    task.failed(error, { accessCode });
    return [];
  }
}
